// ─── TEMĂ (light / dark / auto) ──────────────────────────────────────────────
// Implicit „dark" — comportamentul actual. „auto" urmează tema telefonului.
import React from 'react';
import { t as tr } from './i18n';

const THEME_KEY = "fm_theme";
export function getTheme(){ try{ return localStorage.getItem(THEME_KEY) || "dark"; }catch(e){ return "dark"; } }
export function applyTheme(t){ try{ document.documentElement.setAttribute("data-theme", t); }catch(e){} }
export function setTheme(t){ try{ localStorage.setItem(THEME_KEY, t); }catch(e){} applyTheme(t); }
applyTheme(getTheme());

export function ThemeSelector(){
  const [t, setT] = React.useState(getTheme());
  const opts = [["light","☀️ "+tr("Luminos")],["dark","🌙 "+tr("Întunecat")],["auto","🌗 "+tr("Dispozitiv")]];
  return (
    <div style={{display:"flex",gap:6,background:"var(--bg)",border:"1px solid var(--border)",borderRadius:10,padding:4}}>
      {opts.map(([v,l])=>(
        <button key={v} onClick={()=>{ setTheme(v); setT(v); }}
          style={{flex:1,padding:"8px 6px",borderRadius:7,border:"none",cursor:"pointer",fontFamily:"inherit",fontSize:12.5,
            background: t===v ? "#7c3aed" : "transparent",
            color: t===v ? "#fff" : "var(--text-3)", fontWeight: t===v?600:400}}>
          {l}
        </button>
      ))}
    </div>
  );
}
